import React from 'react';
import {
    Edit,
    SimpleForm,
    BooleanInput,
    TextInput,
    ArrayInput,
    DateField,
    SimpleFormIterator,
    ReferenceInput,
    SelectInput,
    required,
} from 'react-admin';

import OnlySaveToolbar from '../components/only-save-toolbar';
import UserAside from './UserAside'

const renderProfesional = (choice) => choice ? `${choice.nombres} - ${choice.apellidos} - ${choice.matricula}` : '';

const UserEdit = props => (
    <Edit {...props} 
        aside={<UserAside />} 
    >
        <SimpleForm toolbar={<OnlySaveToolbar />}>
            <TextInput source="username" validate={[required()]}/>
            <BooleanInput source="enable"/>
            <DateField source="lastLogin" showTime locales="es-AR"/>
            <ReferenceInput source="matricula" reference="profesionales" label="resources.users.fields.matriculas">
                <SelectInput optionText={renderProfesional} optionValue="matricula"/>
            </ReferenceInput>
            <ArrayInput source="roles" addLabel={false}>
                <SimpleFormIterator >
                    <ReferenceInput source="roleId" reference="roles" label="resources.users.fields.roles"  validate={[required()]}>
                        <SelectInput optionText="description" optionValue="id"/>
                    </ReferenceInput>
                </SimpleFormIterator>
            </ArrayInput>
        </SimpleForm>
    </Edit>
);

export default UserEdit;
